import { useLoaderData } from 'react-router';
import { OfferType } from '../../common/enums';
import { productOfferingsEmptyMessage, productOfferingsEmptyTitle, t } from '../../common/i18n';
import { ProductOfferingsEmptyPageCoCo } from '../EmptyOrError/ProductOfferingsEmptyPageCoCo.js';
import { Grid } from '../Grid/Grid';
import { MobileCarouselWrapper } from '../HorizontalSubscriptionCard/SubscriptionUtils.js';
import { ProductOfferingsCardCoCo } from './ProductOfferingsCardCoCo.js';
import type { ProductOfferingsResponse } from '../../generated/api/productOfferingsResponse.js';

export interface HorizontalSoftwareProductOfferingsCoCoProps {
  publicPages: boolean;
  image?: string; // Optional image prop for future use when contentful asset mapping is introduced.
}

export const HorizontalSoftwareProductOfferingsCoCo = ({
  publicPages,
  image,
}: HorizontalSoftwareProductOfferingsCoCoProps) => {
  const productOfferings = (useLoaderData() as ProductOfferingsResponse[]) ?? [];

  if (productOfferings.length === 0) {
    return (
      <Grid colWidthL={publicPages ? 10 : 12}>
        <ProductOfferingsEmptyPageCoCo
          title={t.ZZWO(productOfferingsEmptyTitle)}
          message={t.ZZWM(productOfferingsEmptyMessage)}
        />
      </Grid>
    );
  }

  return (
    <Grid colWidthL={publicPages ? 10 : 12}>
      <div className="of-subscriptions-main-container of-subscription-card-container-coco">
        <MobileCarouselWrapper>
          {productOfferings.map(offering => (
            <ProductOfferingsCardCoCo
              key={offering.id}
              productOfferings={offering}
              offerType={OfferType.SOFTWARE}
              image={image}
            />
          ))}
        </MobileCarouselWrapper>
      </div>
    </Grid>
  );
};
